<template>
  <div class="expediting-fees-plan-contenzioso2">
    <el-table :data="list" v-loading="loading" style="width: 100%" height="90vh" border>
      <el-table-column label="上年度项目诉讼基础信息" align="center">
        <el-table-column prop="project_name" label="项目名称" align="center" width="200" fixed></el-table-column>
        <el-table-column prop="court_name" label="管辖法院" align="center" width="200"></el-table-column>
        <el-table-column prop="restrictions" label="立案限制（月）" align="center" width="100"></el-table-column>
        <el-table-column label="历史欠费总数据" align="center">
          <el-table-column prop="history_total_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="history_total_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="一年以内欠费" align="center">
          <el-table-column prop="one_year_less_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="one_year_less_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="一年以上欠费" align="center">
          <el-table-column prop="one_year_more_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="one_year_more_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

<!--        <el-table-column label="提交法院取得立案" align="center">-->
<!--          <el-table-column prop="filed_case_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_case_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院取得立案号-未回款" align="center">-->
<!--          <el-table-column prop="filed_no_refund_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_no_refund_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院后立案前成功回款（诉调）" align="center">-->
<!--          <el-table-column prop="pre_filed_settlement_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="pre_filed_settlement_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院未立案未调解未取回" align="center">-->
<!--          <el-table-column prop="filed_no_action_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_no_action_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column label="无诉业主信息/房产资料" align="center">
          <el-table-column prop="no_litigation_info_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="no_litigation_info_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="超过诉讼时效" align="center">
          <el-table-column prop="exceed_limitation_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="exceed_limitation_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
<!--        <el-table-column label="自诉" align="center">-->
<!--          <el-table-column prop="self_prosecution_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="self_prosecution_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="第三方诉讼" align="center">-->
<!--          <el-table-column prop="third_party_litigation_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="third_party_litigation_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--          <el-table-column prop="third_party_name" label="第三方名称" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="已立案数量（含已提交）" align="center">-->
<!--          <el-table-column prop="filed_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
      </el-table-column>
      <el-table-column label="2026年项目年度（一年以上）诉讼计划" align="center" width="4020">
        <el-table-column label="年度目标收缴率（一年以上）" align="center">
          <el-table-column prop="annual_collection_rate" label="收缴率" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_collection_rate_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_collection_rate_amount" label="金额" align="center" width="120"></el-table-column>
<!--          <el-table-column prop="annual_collection_rate_ratio" label="比例" align="center" width="120"></el-table-column>-->
        </el-table-column>
        <el-table-column label="上一年度已立案情况" align="center">
          <el-table-column prop="last_filing_plan_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="last_filing_plan_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

        <el-table-column label="本年立案计划" align="center">
          <el-table-column prop="annual_filing_plan_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_filing_plan_amount" label="金额" align="center" width="120"></el-table-column>
<!--          <el-table-column prop="annual_filing_plan_ratio" label="收缴率占比" align="center" width="120"></el-table-column>-->
        </el-table-column>

        <el-table-column label="本年已立案数量" align="center">
          <el-table-column prop="year_registered_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="year_registered_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="本年立案差异" align="center">
          <el-table-column prop="year_filing_diff_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="year_filing_diff_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

<!--        <el-table-column label="年度自催计划" align="center">-->
<!--          <el-table-column prop="annual_self_collection_plan_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="annual_self_collection_plan_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--          <el-table-column prop="annual_self_collection_plan_ratio" label="收缴率占比" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column label="" align="center" width="2800">
          <template #header>
            <div class="expediting-fees-plan-table-header">
              <el-table :data="[]" :show-header="true" empty-text="" >
                <el-table-column prop="category" label="类目" align="center" width="120"></el-table-column>
                <el-table-column label="1月" align="center">
                  <el-table-column prop="january_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="january_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="2月" align="center">
                  <el-table-column prop="february_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="february_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="3月" align="center">
                  <el-table-column prop="march_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="march_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="4月" align="center">
                  <el-table-column prop="april_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="april_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="5月" align="center">
                  <el-table-column prop="may_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="may_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="6月" align="center">
                  <el-table-column prop="june_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="june_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="7月" align="center">
                  <el-table-column prop="july_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="july_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="8月" align="center">
                  <el-table-column prop="august_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="august_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="9月" align="center">
                  <el-table-column prop="september_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="september_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="10月" align="center">
                  <el-table-column prop="october_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="october_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="11月" align="center">
                  <el-table-column prop="november_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="november_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="12月" align="center">
                  <el-table-column prop="december_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="december_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
<!--                <el-table-column label="年度" align="center">-->
<!--                  <el-table-column prop="annual_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--                  <el-table-column prop="annual_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--                </el-table-column>-->
              </el-table>
            </div>
          </template>
          <template slot-scope="scope">
            <el-table :data="scope.row.yusuan||[]" :show-header="false">
              <el-table-column prop="category" label="类目" align="center" width="120"></el-table-column>
              <el-table-column prop="month_1" label="1月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_2" label="2月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_3" label="3月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_4" label="4月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_5" label="5月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_6" label="6月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_7" label="7月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_8" label="8月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_9" label="9月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_10" label="10月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_11" label="11月" align="center" width="220"></el-table-column>
              <el-table-column prop="month_12" label="12月" align="center" width="220"></el-table-column>
<!--              <el-table-column prop="year" label="年度" align="center" width="220"></el-table-column>-->
            </el-table>
            <el-table :data="scope.row.detail_info||[]" :show-header="false">
              <el-table-column prop="category" label="类目" align="center" width="120"></el-table-column>
              <el-table-column label="1月" align="center">
                <el-table-column prop="january_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="january_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="2月" align="center">
                <el-table-column prop="february_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="february_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="3月" align="center">
                <el-table-column prop="march_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="march_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="4月" align="center">
                <el-table-column prop="april_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="april_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="5月" align="center">
                <el-table-column prop="may_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="may_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="6月" align="center">
                <el-table-column prop="june_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="june_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="7月" align="center">
                <el-table-column prop="july_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="july_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="8月" align="center">
                <el-table-column prop="august_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="august_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="9月" align="center">
                <el-table-column prop="september_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="september_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="10月" align="center">
                <el-table-column prop="october_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="october_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="11月" align="center">
                <el-table-column prop="november_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="november_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
              <el-table-column label="12月" align="center">
                <el-table-column prop="december_num" label="户数" align="center" width="100"></el-table-column>
                <el-table-column prop="december_amount" label="金额" align="center" width="120"></el-table-column>
              </el-table-column>
<!--              <el-table-column label="年度" align="center">-->
<!--                <el-table-column prop="annual_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--                <el-table-column prop="annual_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--              </el-table-column>-->
            </el-table>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "ExpeditingFeesPlanContenzioso3",
  data() {
    return {
      loading:false,
      list:[],
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      const that=this;
      that.loading=true;
      let where = {
        batch_number:that.$route.query.batch_number,
      }
      ButlerHttp.post("YearPlan/getListByBatchNumber",{
        ...where
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.list=ret.data;
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.expediting-fees-plan-contenzioso2{
  .expediting-fees-plan-table-header{
    >>>.el-table__empty-block{
      display:none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ExpeditingFeesPlanContenzioso3.vue